import { FC } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";

export interface PageVerifyEmailProps {
  className?: string;
}

const PageVerifyEmail: FC<PageVerifyEmailProps> = ({ className = "" }) => {
  const { t } = useTranslation();

  const location = useLocation();
  const email = location.state?.email;

  return (
    <div className={`nc-PageVerifyEmail ${className}`} data-nc-id="PageVerifyEmail">
      <Helmet>
        <title>{t('connexion')}</title>
      </Helmet>
      <div className="container mb-24 lg:mb-32">
        <h2 className="my-10 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
        {t('emailVerificationTitle')}
        </h2>
        <div className="max-w-md mx-auto text-center space-y-3">
          <div>

            <p>
              {t('emailVerificationSent')} {email}
                          <br/>
                          <br/>
                          {t('emailVerificationInstruction')}
            </p>
          </div>
   
        </div>
      </div>


    </div>
  );
};

export default PageVerifyEmail;
